<script>
    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';
    import History from '@js/modules/history';

    import {mapStore} from '@js/stores/mapStore';

    import ComboSearch from '@js/components/search/ComboSearch.svelte';

    import PWAManager from '@js/modules/pwaManager';
    import AnalyticsService from '@js/modules/analyticsService';
    import Notification from '@js/components/layouts/notification';

    const {
        mapId = 'home-map-container'
    } = $props();

    const LOCATION_HISTORY_NAME = 'home_location_data';

    const initialLocationData = History.getPreviousState(LOCATION_HISTORY_NAME, {useUrlParams: true});

    const _saveHistory = (selectedLocation) => {
        const locationParams = {
            name: selectedLocation.name,
            value: selectedLocation.value,
            type: selectedLocation.type,
            placeType: selectedLocation.placeType,
            bbox: !!selectedLocation.bbox ? [...selectedLocation.bbox] : null,
            center: !!selectedLocation.center ? [...selectedLocation.center] : null
        };

        History.saveCurrentState(
            {
                [LOCATION_HISTORY_NAME]: locationParams
            },
            {
                name: selectedLocation.name,
                center: selectedLocation.center,
                placeType: selectedLocation.placeType
            }
        );
    };

    const _onHistoryChange = (onHistoryCallback) => {
        History.onStateChange((newState) => {
            if (newState[LOCATION_HISTORY_NAME]) {
                onHistoryCallback(newState[LOCATION_HISTORY_NAME]);
            }
        });
    };

    const _handleLocateMe = () => {
        Notification.info(I18n.t('js.maps.geolocation.in_progress'));

        AnalyticsService.trackGeolocationClick('Home page');

        if (mapStore.map && mapStore.map.onGeolocation) {
            AnalyticsService.trackGeolocationClick('Planner page');

            mapStore.map.onGeolocation(
                (userLocation) => {
                    setTimeout(() => {
                        Utils.scrollTo(mapId);

                        mapStore.mapLocation = {
                            type: 'location',
                            bbox: undefined,
                            center: [userLocation.longitude, userLocation.latitude],
                            placeType: 'geolocation',
                            value: 'geolocation'
                        };

                        // Clear current path on map on new search and ask for deletion
                        if (mapStore.map) {
                            mapStore.map.clearMap();
                        }

                        if (mapStore.map && mapStore.map.hasModule('HELPER') && mapStore.map.displayMapHelper) {
                            mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.position_as_start'));
                        }
                    }, 350);

                    setTimeout(() => Notification.hide(), 600);
                },
                () => {
                    setTimeout(() => Utils.scrollTo(mapId), 350);
                });
        }
    };

    const _handleSelectOnMap = () => {
        AnalyticsService.trackHomeShowMapClick();

        setTimeout(() => {
            Utils.scrollTo(mapId);

            if (mapStore.map && mapStore.map && mapStore.map.hasModule('HELPER') && mapStore.map.displayMapHelper) {
                mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.click_on_map'));
            }
        }, 350);
    };

    const handleSubmit = (comboSearch, {track = true} = {}) => {
        if (comboSearch.location?.name) {
            if (track) {
                AnalyticsService.trackHomeShowPlaceSelected();
                AnalyticsService.trackSearch('Home page', undefined, `${comboSearch.location.value} (${comboSearch.location.placeType})`, 1);
            }

            // Clear current path on map on new search and ask for deletion
            if (mapStore.map) {
                mapStore.map.clearMap();
            }

            mapStore.mapLocation = comboSearch.location;

            _saveHistory(comboSearch.location);

            setTimeout(() => Utils.scrollTo(mapId), 100);
        }

        if (comboSearch.useMyPosition) {
            _handleLocateMe();
        } else if (comboSearch.selectOnMap) {
            _handleSelectOnMap();
        } else if (mapStore.map && mapStore.map.hasModule('HELPER') && mapStore.map.displayMapHelper) {
            mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.draw_path'));
        }
    };

    _onHistoryChange((newLocationData) => {
        handleSubmit(newLocationData, {track: false});
    });
</script>

<div class="home-search-form">
    <form id="global-search"
          class="search"
          accept-charset="UTF-8"
          autocomplete="off"
          novalidate="novalidate"
          onsubmit={handleSubmit}>
        <ComboSearch id="home-search-input"
                     formId="home-search"
                     isFullWidth={true}
                     placeholder={I18n.t('js.views.home.search.placeholder')}
                     searchFeatures={['location']}
                     autoFocus={PWAManager.getPWADisplayMode() === PWAManager.MODE.BROWSER}
                     initialValue={initialLocationData?.value || initialLocationData?.name}
                     useRecentSearch={true}
                     useFirstQueryOnEnter={true}
                     useSubmitOnSelect={true}
                     useIsochrone={false}
                     useRideType={false}
                     onSubmit={handleSubmit}/>
    </form>
</div>
